import { TRoomDetail } from '@/entities/room'
import { isNilOrEmptyString } from '@/shared/lib'

import { ExpandableText, Heading } from '../common'

export type Props = Pick<TRoomDetail, 'additionalDescription'>

export const AdditionalDescription = ({ additionalDescription }: Props) => {
  if (isNilOrEmptyString(additionalDescription)) return null

  return (
    <section className="w-full space-y-3">
      <Heading>추가 설명</Heading>
      <ExpandableText content={additionalDescription} />
    </section>
  )
}
